import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Table from "../../common/Table";
import RelativeLink from "../../common/RelativeLink";
import Tooltip from "../../common/Tooltip";
import * as DomainConstants from '../../../constants/DomainConstants';
import InSamenWerkingMetLogos from "../../common/InSamenWerkingMetLogos";
import * as ComponentConstants from '../../../constants/ComponentConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCheck } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import Row from "../../common/Row";
import Col from "../../common/Col";
import Button from "../../common/Button";
import SelectInput from "../../common/SelectInput";
import { getIcoonDataUri } from "../../../util/tochtTypeIcoon";

const mapToelatingGemeente = (toelating) => {
	switch (toelating) {
		case true:
			return 'Goedgekeurd';
		case false:
			return 'Afgekeurd';
		default:
			return 'Onbeslist';
	}
};

const VTTPerGemeenteForm = (props) => {
	const {
		model,
		tochtTypes,
		selectedTochtBehandelaar,
		tochtBehandelaars,
		onTochtBehandelaarChange
	} = props;

	const tableHeadersNogTeBehandelen = ["INFO", "ORGANISATOR", "DATUM", "TOCHT", "GEMEENTEN", "JOUW BEOORDELING", ""];
	const tableHeaderSizesNogTeBehandelen = [8, 17, 11, 25, 21, 12, 6];
	const tableHeadersBehandeldeAfgelopen = ["INFO", "ORGANISATOR", "DATUM", "TOCHT", "GEMEENTEN", "JOUW BEOORDELING", ""];
	const tableHeaderSizesBehandeldeAfgelopen = [8, 17, 11, 25, 21, 12, 6];
	const tableHeadersToekomendeOnvolledige = ["INFO", "ORGANISATOR", "DATUM", "TOCHT", "GEMEENTEN"];
	const tableHeaderSizesToekomendeOnvolledige = [9, 19, 11, 31, 30];

	const tochBehandelaarNietSVL = selectedTochtBehandelaar !== DomainConstants.TochtBehandelaars.SPORTVLAANDEREN;

	if (tochBehandelaarNietSVL) {
		tableHeadersNogTeBehandelen.pop();
		tableHeaderSizesNogTeBehandelen.pop();
		tableHeadersBehandeldeAfgelopen.pop();
		tableHeaderSizesBehandeldeAfgelopen.pop();
	}

	const teBehandelen = model.nogTeBehandelenTochten;
	const behandeldeAfgelopen = model.behandeldeAfgelopenTochten;
	const toekomendeOnvolledige = model.toekomendeOnvolledigeTochten;
	const nogTeBehandelenRows = teBehandelen && teBehandelen.length ? createnogTeBehandelenRows(teBehandelen) : null;
	const behandeldeAfgelopenTochtenRows = behandeldeAfgelopen && behandeldeAfgelopen.length ? createBehandeldeAfgelopenRows(behandeldeAfgelopen) : null;
	const toekomendeOnvolledigeTochtenRows = toekomendeOnvolledige && toekomendeOnvolledige.length ? createToekomstigeRows(toekomendeOnvolledige) : null;

	function getTochtTypeIcoon(tochtTypeId) {
		const tochtType = tochtTypes && tochtTypes.find(x => x.id === tochtTypeId);
		if (!tochtType || !tochtType.icoonBase64)
			return null;

		return <img className="tochttype-icoon" src={getIcoonDataUri(tochtType.icoonBase64)} title={tochtType.naam} alt={tochtType.naam} />;
	}

	function getOverlappingTooltip(tocht) {
		if (!tocht.heeftOverlapping)
			return null;

		return <Tooltip
			icon={ComponentConstants.TOOLTIP_ICON_EXCLAMATION_TRIANGLE}
			text={"Er loopt een andere tocht op dezelfde dag over (een deel van) dezelfde route."}
			tooltipType={ComponentConstants.TOOLTIP_WARNING}
			iconColor={ComponentConstants.COLOR_ORANGE}
			windowWidth={30} />;
	}

	function createnogTeBehandelenRows(tochtenArray) {
		return tochtenArray.map((tocht, i) => {
			return (<tr key={tocht.id}>
				<td>
					<RelativeLink to={"/e-loket/organisator/" + tocht.id + "/gemeente" + "/true"} title="detail tocht"><i className="fa fa-file-text-o fa-fw"></i></RelativeLink>
					<RelativeLink to={"/e-loket/gemeente/pdf/" + tocht.id} title="genereer PDF"><i className="fa fa-file-pdf-o fa-fw"></i></RelativeLink>
				</td>
				<td>{tocht.organisator}</td>
				<td>{moment(tocht.datum).format("DD/MM/YYYY")}</td>
				<td>{getTochtTypeIcoon(tocht.tochtTypeId)} {tocht.svlDossierId} {tocht.naam} {getOverlappingTooltip(tocht)}</td>
				<td>{tocht.gemeenten}</td>
				<td>Onbeslist {tocht.opmerkingToelating ?
					<Tooltip
						text={tocht.opmerkingToelating}
						tooltipType={ComponentConstants.TOOLTIP_INFO}
						iconColor={ComponentConstants.COLOR_GREEN}
						windowWidth={30} /> : ''}</td>
				{!tochBehandelaarNietSVL &&
					<td>
						<RelativeLink to={"/e-loket/gemeente/toelating/" + tocht.id} title="geef goedkeuring in"><FontAwesomeIcon icon={faUserCheck} /></RelativeLink>
					</td>
				}
			</tr>);
		});
	}

	function createToekomstigeRows(tochtenArray) {
		return tochtenArray.map((tocht, i) => {
			return (<tr key={tocht.id}>
				<td>
					<RelativeLink to={"/e-loket/organisator/" + tocht.id + "/gemeente" + "/true"} title="detail tocht"><i className="fa fa-file-text-o fa-fw"></i></RelativeLink>
					<RelativeLink to={"/e-loket/gemeente/pdf/" + tocht.id} title="genereer PDF"><i className="fa fa-file-pdf-o fa-fw"></i></RelativeLink>
				</td>
				<td>{tocht.organisator}</td>
				<td>{moment(tocht.datum).format("DD/MM/YYYY")}</td>
				<td>{getTochtTypeIcoon(tocht.tochtTypeId)} {tocht.svlDossierId} {tocht.naam}</td>
				<td>{tocht.gemeenten}</td>
			</tr>);
		});
	}

	function createBehandeldeAfgelopenRows(tochtenArray) {
		return tochtenArray.map((tocht, i) => {
			return (<tr key={tocht.id}>
				<td>
					<RelativeLink to={"/e-loket/organisator/" + tocht.id + "/gemeente" + "/true"} title="detail tocht"><i className="fa fa-file-text-o fa-fw"></i></RelativeLink>
					<RelativeLink to={"/e-loket/gemeente/pdf/" + tocht.id} title="genereer PDF"><i className="fa fa-file-pdf-o fa-fw"></i></RelativeLink>
				</td>
				<td>{tocht.organisator}</td>
				<td>{moment(tocht.datum).format("DD/MM/YYYY")}</td>
				<td>{getTochtTypeIcoon(tocht.tochtTypeId)} {tocht.svlDossierId} {tocht.naam} {getOverlappingTooltip(tocht)}</td>
				<td>{tocht.gemeenten}</td>
				<td> {[mapToelatingGemeente(tocht.toelatingVanGemeente), tocht.opmerkingToelating ?
					<Tooltip
						text={tocht.opmerkingToelating}
						tooltipType={ComponentConstants.TOOLTIP_INFO}
						iconColor={ComponentConstants.COLOR_GREEN}
						windowWidth={30} /> : '']}</td>
				{!tochBehandelaarNietSVL &&
					<td>
						{moment(tocht.datum) > moment() ? <RelativeLink to={"/e-loket/gemeente/toelating/" + tocht.id} title="geef goedkeuring in"><FontAwesomeIcon icon={faUserCheck} /></RelativeLink> : ''}
					</td>
				}
			</tr>);
		});
	}

	function scrollToElement(sectionId) {
		return () => {
			const section = document.querySelector(sectionId);
			section.scrollIntoView({ behavior: 'smooth', block: 'start' });
		};
	}

	return (
		<Fragment>
			<Section classes="body-bg">
				<Row>
					<Col size={12}>
						<h3 className="c-gemeenteOverzicht__button-titles">Navigeer naar:</h3>
					</Col>
				</Row>
				<Row>
					<Button
						onClick={scrollToElement('.teBehandelen')}
						text={"Te behandelen"} />

					{(behandeldeAfgelopen && behandeldeAfgelopen.length) ?
						<Button
							onClick={scrollToElement('.behandeldeAfgelopen')}
							text={"Behandeld en afgelopen"} /> : null
					}
					{(toekomendeOnvolledige && toekomendeOnvolledige.length) ?
						<Button
							onClick={scrollToElement('.teVervolledigen')}
							text={"Te vervolledigen"} /> : null
					}
				</Row>
			</Section>

			<Section
				title={'Te behandelen tochten'}
				color={ComponentConstants.COLOR_BLUE}
				id="teBehandelen"
				canScrollToTop>
				<Section>
					{(teBehandelen && teBehandelen.length > 0) ?
						<Table headers={tableHeadersNogTeBehandelen} headerSizes={tableHeaderSizesNogTeBehandelen}>
							{nogTeBehandelenRows}
						</Table>
						:
						<p>Er zijn nog geen tochten toegevoegd</p>}
				</Section>
			</Section>

			{!(behandeldeAfgelopen && behandeldeAfgelopen.length) ||
				<Section
					title={'Behandelde en afgelopen tochten'}
					color={ComponentConstants.COLOR_GREEN}
					id="behandeldeAfgelopen"
					canScrollToTop>
					<Section>
						<Table headers={tableHeadersBehandeldeAfgelopen} headerSizes={tableHeaderSizesBehandeldeAfgelopen}>
							{behandeldeAfgelopenTochtenRows}
						</Table>
					</Section>
				</Section>}

			{!(toekomendeOnvolledige && toekomendeOnvolledige.length) ||
				<Section
					title={'Te vervolledigen tochten door organisator'}
					color={ComponentConstants.COLOR_TURQUOISE_DARK}
					id="teVervolledigen"
					canScrollToTop>
					<Section>
						<Table headers={tableHeadersToekomendeOnvolledige} headerSizes={tableHeaderSizesToekomendeOnvolledige}>
							{toekomendeOnvolledigeTochtenRows}
						</Table>
					</Section>
				</Section>}

			<Section classes="body-bg">
				<h3 className="c-gemeenteOverzicht__button-titles">Indien je wenst de aanvragen te beoordelen via je eigen gemeentelijke evenementenapplicatie,
					dan kun je dit hieronder aanduiden. Kies 'Sport Vlaanderen' als je via de e-tool wenst te beoordelen. Indien je kiest voor een externe partij dan zal het beoordelen in de e-tool niet langer mogelijk zijn.
					Je zult nog wel (toekomstige) tochten kunnen bekijken.</h3>

				<SelectInput
					name="tochtBehandelaar"
					label="Vertegenwoordigd door"
					value={selectedTochtBehandelaar}
					onChange={onTochtBehandelaarChange}
					items={tochtBehandelaars}
				/>
			</Section>

			<InSamenWerkingMetLogos />
		</Fragment>
	);
};

VTTPerGemeenteForm.propTypes = {
	model: PropTypes.object,
	tochtTypes: PropTypes.array,
	tochtBehandelaars: PropTypes.array,
	selectedTochtBehandelaar: PropTypes.string,
	onTochtBehandelaarChange: PropTypes.func,
	onNew: PropTypes.func,
	disabled: PropTypes.bool,
	readonly: PropTypes.bool
};

export default VTTPerGemeenteForm;
